// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchUpcomingCatalogsIfNeeded } from '../../../redux/modules/upcomingCatalogs';
import { recordAnalyticsForTrendingPageView } from '../../../redux/modules/analytics';

export const MAX_TODAY_AUCTIONS = 150; // remove this if our business really picks up...

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return Promise.all([dispatch(fetchUpcomingCatalogsIfNeeded(MAX_TODAY_AUCTIONS, true))]).then(() => {
        return dispatch(recordAnalyticsForTrendingPageView());
    });
};
